import { Component, ElementRef, Input, OnInit } from '@angular/core';

@Component({
  selector: 'uex-grid',
  template: `<div class="row"

    [class.align-self-start]="alignSelf == 'start'"
    [class.align-self-center]="alignSelf == 'center'"
    [class.align-self-end]="alignSelf == 'end'"
    [class.align-self-baseline]="alignSelf == 'baseline'"
    [class.align-self-stretch]="alignSelf == 'stretch'"

    [class.align-items-start]="alignItems == 'start'"
    [class.align-items-center]="alignItems == 'center'"
    [class.align-items-end]="alignItems == 'end'"
    [class.align-items-baseline]="alignItems == 'baseline'"
    [class.align-items-stretch]="alignItems == 'stretch'"

    [class.align-content-start]="alignContent == 'start'"
    [class.align-content-center]="alignContent == 'center'"
    [class.align-content-end]="alignContent == 'end'"
    [class.align-content-between]="alignContent == 'between'"
    [class.align-content-around]="alignContent == 'around'"
    [class.align-content-stretch]="alignContent == 'stretch'"

    [class.justify-content-start]="justifyItems == 'start'"
    [class.justify-content-center]="justifyItems == 'center'"
    [class.justify-content-end]="justifyItems == 'end'"
    [class.justify-content-between]="justifyItems == 'between'"
    [class.justify-content-around]="justifyItems == 'around'"
    [class.justify-content-stretch]="justifyItems == 'stretch'"

    ><ng-content></ng-content></div>
  `,
  host: {
    class: 'uex-grid container-fluid'
  }
})
export class GridComponent implements OnInit {
  @Input('alignSelf') public alignSelf: string = null;
  @Input('alignItems') public alignItems = 'start';
  @Input('alignContent') public alignContent: string = null;
  @Input('justifyItems') public justifyItems: string = null;

  constructor(
    public elementRef: ElementRef
  ) { }

  ngOnInit() { }

  public get offsetTop(): number {
    return this.elementRef.nativeElement.offsetTop;
  }
}
